export default __webpack_public_path__ + "static/media/21.bce955a5.jpg";